import { MachineClaimingPairing } from 'app/modules/machine-directory/machine-claiming-pairing/components/MachineClaimingPairing';

export const MachineClaimingPairingPage = (): JSX.Element => <MachineClaimingPairing />;
